export default "Panorama des aides à l'efficacité énergétique pour ETI et grands comptes : CEE BAT et IND, Fonds Chaleur ADEME, fonds de décarbonation France 2030 et suramortissement fiscal.";
